export default "__VITE_ASSET__BeWCyeSP__"